export interface PurchaserData {
  name: string;
  email: string;
  price: number;
}

export const formatPurchaserData = ({ name, email, price }: PurchaserData) =>
  `${name}, ${email} (${price}zł)`;
